import { render, staticRenderFns } from "./user_delete_form.vue?vue&type=template&id=7287018e"
import script from "./user_delete_form.vue?vue&type=script&lang=js"
export * from "./user_delete_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports